import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { QuantumField } from "./components/QuantumField";
import { QuantumProvider } from "./components/QuantumTransitions";
import { GlobalNav } from "./components/PageShell";
import { AuthProvider } from "./context/AuthContext";
import Opening from "./pages/Opening";
import Create from "./pages/Create";
import Journey from "./pages/Journey";
import Mirror from "./pages/Mirror";
import Compare from "./pages/Compare";
import Chat from "./pages/Chat";
import Plan from "./pages/Plan";
import Journal from "./pages/Journal";
import Login, { AuthCallback } from "./pages/Login";
import Pricing, { PaymentSuccess } from "./pages/Pricing";
import Decisions from "./pages/Decisions";
import Multiverse from "./pages/Multiverse";
import Self from "./pages/Self";
import Council from "./pages/Council";
import Collide from "./pages/Collide";
import Lab from "./pages/Lab";
import Letters from "./pages/Letters";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Opening />} />
      <Route path="/create" element={<Create />} />
      <Route path="/journey/:id" element={<Journey />} />
      <Route path="/mirror/:id" element={<Mirror />} />
      <Route path="/compare/:id" element={<Compare />} />
      <Route path="/chat/:id" element={<Chat />} />
      <Route path="/plan/:id" element={<Plan />} />
      <Route path="/journal/:id" element={<Journal />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/decisions/:id" element={<Decisions />} />
      <Route path="/multiverse/:id" element={<Multiverse />} />
      <Route path="/self/:sid" element={<Self />} />
      <Route path="/council/:id" element={<Council />} />
      <Route path="/collide/:id" element={<Collide />} />
      <Route path="/lab/:id" element={<Lab />} />
      <Route path="/letters/:id" element={<Letters />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App noise">
      <QuantumField />
      <div style={{ position: "relative", zIndex: 1, paddingTop: 40 }}>
        <BrowserRouter>
          <AuthProvider>
            <QuantumProvider>
              <GlobalNav />
              <AppRoutes />
            </QuantumProvider>
          </AuthProvider>
        </BrowserRouter>
      </div>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
